import Button from 'ext-ui/components/Button/Button'
import React from 'react'
import * as style from 'src/app/BulkInvite/components/ErrorState.style'

interface ErrorStateProps {
  title: string
  detail?: string
  onRetry?: () => void
  retryLabel?: string
}

/** Centered error message with an optional retry action. */
const ErrorState: React.FC<ErrorStateProps> = ({
  title,
  detail,
  onRetry,
  retryLabel,
}) => (
  <div css={style.container} role="alert">
    <div css={style.title}>{title}</div>
    {detail !== undefined && <div css={style.detail}>{detail}</div>}
    {onRetry !== undefined && retryLabel !== undefined && (
      <Button variant="secondary" onClick={onRetry} testId="bulkInviteRetry">
        {retryLabel}
      </Button>
    )}
  </div>
)

export default ErrorState
